import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { LocalizedText, useDialog, useFeatureFlag } from '@mews/framework';
import { Role, RoleGetResult } from '@mews-commander/data-access';
import { IconButton, ButtonVariant, IconName, Sized, Variable } from '@optimus-web/core';
import { EnterpriseLinkIconButton, TooltippedSpan } from '@mews-commander/ui';
import { usePortfolioSelectors } from '../utils';
import { EditRoleDialog } from './EditRoleDialog';

export const EditRoleCell = ({
    role,
    size = 'small',
    variant = 'ghost',
}: { role: RoleGetResult | Role } & Sized & Variable<ButtonVariant>) => {
    const { isPortfolio } = usePortfolioSelectors();
    const isDisabled = !isPortfolio && !role.isLocal;
    const [editRoleDialogProps, toggleEditRoleDialog] = useDialog();

    const newPermissionsEnabled = useFeatureFlag(FeatureFlag.newPermissionsEnabled);

    return (
        <>
            <TooltippedSpan
                tooltip={isDisabled ? <LocalizedText textKey={TextKey.RoleEditPortfolioOnlyTooltip} /> : null}
                tooltipDelay={300}
            >
                {newPermissionsEnabled ? (
                    <EnterpriseLinkIconButton
                        icon={IconName.Edit}
                        size={size}
                        variant={variant}
                        disabled={isDisabled}
                        type="button"
                        to="Roles/$roleId/Edit"
                        params={{ roleId: role.id }}
                    />
                ) : (
                    <IconButton
                        icon={IconName.Edit}
                        onClick={toggleEditRoleDialog}
                        size={size}
                        variant={variant}
                        disabled={isDisabled}
                        type="submit"
                    />
                )}
            </TooltippedSpan>
            <EditRoleDialog role={role} {...editRoleDialogProps} />
        </>
    );
};
